<template>
  <div>
    <template v-if="permissionDetail">
      <topsearch :title="permissionDetail.name" />
      <TransactionList
        :table="table"
        :permissions="permissionDetail"
        :tablename="permissionDetail.name"
        detailurl="/detail/"
      />
    </template>
  </div>
</template>

<script>
import TransactionList from "../components/Datatable/TransactionList";

export default {
  name: "list",
  components: { TransactionList },
  data() {
    return {
      table: "transactions",
      permissionMap: [],
      tableInfo: {},
    };
  },
  computed: {
    permissionDetail() {
      return this.$root.cache.permissions.find((e) => e.table == this.table);
    },
  },
};
</script>
